export const packagesData = [
  {
    id: 1,
    label: "Silver",
    price: "800k",
    duration: "Per Tahun",
    features: [
      {
        describe: "Pembuatan Halaman",
        active: true,
        value: "4 Halaman",
      },
      {
        describe: "Waktu Pengerjaan",
        active: true,
        value: "14 Hari",
      },
      {
        describe: "Landing / Company Profile",
        active: true,
        value: "approved",
      },
      {
        describe: "Mobile Friendly",
        active: true,
        value: "approved",
      },
      {
        describe: "SEO Friendly",
        active: true,
        value: "approved",
      },
      {
        describe: "Free SSL",
        active: true,
        value: "approved",
      },
      {
        describe: "Modern Design",
        active: true,
        value: "approved",
      },
      {
        describe: "Free Domain (.web.id)",
        active: true,
        value: "approved",
      },
      {
        describe: "Free Konsultasi",
        active: true,
        value: "approved",
      },
      {
        describe: "Biaya Perpanjangan",
        active: true,
        value: "700k",
      },
    ],
  },
  {
    id: 2,
    label: "Gold",
    price: "1,45jt",
    duration: "Per Tahun",
    features: [
      {
        describe: "Pembuatan Halaman",
        active: true,
        value: "8 Halaman",
      },
      {
        describe: "Waktu Pengerjaan",
        active: true,
        value: "21 Hari",
      },
      {
        describe: "Landing / Company Profile",
        active: true,
        value: "approved",
      },
      {
        describe: "Mobile Friendly",
        active: true,
        value: "approved",
      },
      {
        describe: "SEO Friendly",
        active: true,
        value: "approved",
      },
      {
        describe: "Free SSL",
        active: true,
        value: "approved",
      },
      {
        describe: "Modern Design",
        active: true,
        value: "approved",
      },
      {
        describe: "Free Domain (.com)",
        active: true,
        value: "approved",
      },
      {
        describe: "Free Konsultasi",
        active: true,
        value: "approved",
      },
      {
        describe: "Biaya Perpanjangan",
        active: true,
        value: "800k",
      },
    ],
  },
  {
    id: 3,
    label: "Diamond",
    price: "2jt",
    duration: "Per Tahun",
    features: [
      {
        describe: "Pembuatan Halaman",
        active: true,
        value: "10 Halaman",
      },
      {
        describe: "Waktu Pengerjaan",
        active: true,
        value: "21 Hari",
      },
      {
        describe: "Landing / Company Profile",
        active: true,
        value: "approved",
      },
      {
        describe: "Mobile Friendly",
        active: true,
        value: "approved",
      },
      {
        describe: "SEO Friendly",
        active: true,
        value: "approved",
      },
      {
        describe: "Free SSL",
        active: true,
        value: "approved",
      },
      {
        describe: "Modern Design",
        active: true,
        value: "approved",
      },
      {
        describe: "Free Domain (.com / .co.id)",
        active: true,
        value: "approved",
      },
      {
        describe: "Free Konsultasi",
        active: true,
        value: "approved",
      },
      {
        describe: "Biaya Perpanjangan",
        active: true,
        value: "900k",
      },
    ],
  },
];
